import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { coberturasTratamento, papeisAssinatura } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class EmailsNotificacaoEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            email: '',
            codigo_email: '',
            emailHelper: '',
            codigo_emailHelper: '',
            erroLoadRegistro: "",
            email_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                email_id: id,
                titulo_pagina: 'Editando Email de Notificação',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/configuracoes/emails-notificacao/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    email: dados.email,
                    codigo_email: dados.codigo_email,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar email, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                email_id: '',
                titulo_pagina: 'Adicionar Email de Notificação',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.email_id) ? '/configuracoes/emails-notificacao/'+this.state.email_id+'/' : '/configuracoes/emails-notificacao/'
        const metodo = (this.state.email_id) ? 'put' : 'post'

        formData.append('email', this.state.email);
        formData.append('codigo_email', this.state.codigo_email);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.email_id) ? 'Email atualizado com sucesso' : 'Email cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.email_id){
                this.props.router.navigate("/emails-notificacao");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o email, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'codigo_email'){
                        this.setState({ codigo_emailHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleQuillChange = (value) => {
        this.setState({ texto: value });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosEmail" id="tabs-email" className="aditus-tabs">
                    <Tab eventKey="dadosEmail" title="Dados do Email">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Email</h4>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email: <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="email" name="email" required placeholder="Email" value={this.state.email} onChange={this.handleChange} />    
                                                <Form.Text id="formEmailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>   
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3" >
                                                <Form.Label>Código do Email: <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="codigo_email" required placeholder="Código do Email" value={this.state.codigo_email} onChange={this.handleChange} />    
                                                <Form.Text id="formEmailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>   
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(EmailsNotificacaoEdit);